<button class="flex items-center gap-2 px-3 py-2 rounded-xl border border-n30 text-n700 text-sm font-medium hover:bg-n10 transition-colors" (click)="back()">
  <i class="ph ph-arrow-left text-base"></i>
  Back
</button>
